var Request = require('../helper/request');
var Extension = require('./extension');
var Hashtag = require('./hashtag');
var Mention = require('./mention');
var Location = require('./location');
var Significant = require('./significant');
var Survey = require('./survey');
var SurveyConnection = require('./surveyConnection');
var Event = require('./event');
var Comment = require('./comment');
var Content = require('./content');
var Like = require('./like');
var Tag = require('./tag');
var Public = require('./public');

function Feed(app){
  var self = this;
  self.request = new Request(app);
  self.app = app;

  self.routes = {
    show: {
      url: "/feed/:id",
      method: "GET"
    },
    create: {
      url: "/feed",
      method: "POST"
    },
    update: {
      url: "/feed/:id",
      method: "PUT"
    },
    delete: {
      url: "/feed/:id",
      method: "DELETE"
    }
  };
}

Feed.prototype.show = function(id){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id);
  return self.request.get(uri);
};

Feed.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    feed: data
  });
};

Feed.prototype.update = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.put(uri, {
    feed: data
  });
};

Feed.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri);
};

Feed.prototype.extension = function(feedId){
  var self = this;
  return new Extension(self.app, feedId);
};

Feed.prototype.hashtag = function(feedId){
  var self = this;
  return new Hashtag(self.app, feedId);
};

Feed.prototype.mention = function(feedId){
  var self = this;
  return new Mention(self.app, feedId);
};

Feed.prototype.location = function(feedId){
  var self = this;
  return new Location(self.app, feedId);
};

Feed.prototype.significant = function(feedId){
  var self = this;
  return new Significant(self.app, feedId);
};

Feed.prototype.survey = function(feedId){
  var self = this;
  return new Survey(self.app, feedId);
};
Feed.prototype.surveyConnection = function(feedId){
  var self = this;
  return new SurveyConnection(self.app, feedId);
};

Feed.prototype.event = function(feedId){
  var self = this;
  return new Event(self.app, feedId);
};

Feed.prototype.comment = function(feedId){
  var self = this;
  return new Comment(self.app, feedId);
};

Feed.prototype.content = function(feedId){
  var self = this;
  return new Content(self.app, feedId);
};

Feed.prototype.like = function(feedId){
  var self = this;
  return new Like(self.app, feedId);
};

Feed.prototype.tag = function(feedId){
  var self = this;
  return new Tag(self.app, feedId);
};
Feed.prototype.public = function(feedId){
  var self = this;
  return new Public(self.app, feedId);
};

module.exports = Feed;
